import CryptoJS from "crypto-js";

export function encrypt(plainText) {
  try {
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    const key = CryptoJS.SHA256(secretKey);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(String(plainText), key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // 🔥 FIX: use ciphertext properly
    const encryptedBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

    return `${ivBase64}:${encryptedBase64}`;
  } catch (err) {
    console.error("Encryption error:", err.message);
    return null;
  }
}